<script>
    import { timeStore } from '../../stores';
    import { config } from '../../../scripts/defaultURL';
    import DeleteTimeModal from './DeleteTime.svelte';
    // import { clearForm, formatDate, openModal } from '../../../scripts/functions';
    import { clearForm, formatDate, formatPayloadDate } from '../../../scripts/functions';
    import { updateData } from '../../../scripts/rest';

    export let time;
    export let categoryOptions;
    let timeDate = formatDate(time.date);
    let deleteTimeModal = false;

    $: console.table(time);

    function closeModal() {
        clearForm('#editTimeModal input');
        document.getElementById('editTimeModal').classList.remove('is-active')
        $timeStore['todo'] = 'getData'
    } 
  
    function save(e) {
        const payload = {
            id: time.id,
            minutes: document.querySelector('#minutes').value,
            category: document.querySelector('#category').value,
            client_id: (time.client_id) ? time.client_id : null,
            date: formatPayloadDate(document.querySelector('#date').value),
            description: document.querySelector('#description').value,
            income_expense: time.income_expense
        };

        console.log('payload',payload);
  
        updateData(`${config.defaultURL}/times/update/${payload.id}`, payload)
        .catch((error) => console.error('Failed to update time:', error))
        .then((res) => {
            console.log(res)
            closeModal()
            e.target.reset()
        })
    }

    // function deleteTime(item) {
    //     console.log('time:', item);
    //     deleteTimeModal = true;
        
    //     openModal('deleteTimeModal');
    // }
  </script>
  
<style>
    .modal-card-title {
        margin-bottom: 0 !important;
    }
</style>
    
<div class="modal" id="editTimeModal">
    <div class="modal-background" />
    <div class="modal-card">
        <header class="modal-card-head">
        <p class="modal-card-title">Edit time</p>
        <button on:click={closeModal} class="delete" aria-label="close" />
        </header>
        <section class="modal-card-body">
            <form on:submit|preventDefault={save}>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Date</label>
                    <input id="date" value={timeDate} class="input" type="date" name="date" placeholder="Enter Scan Date" required />
                </div>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Minutes</label>
                    <div style="display:flex;">
                        <div style="width: 100%;">
                            <input style="width: 100%" id="minutes" value={time.minutes} class="input" name="minutes" type="text" />
                        </div>
                </div>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Description</label>
                    <textarea id="description" value={time.description} class="textarea" name="description"></textarea>
                </div>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Category</label>
                    <input id="category" list="categories" value={time.category} class="input" name="category" placeholder="time Category (optional)" />
                        <datalist id="categories">
                            {#each categoryOptions as category}
                            <option>{category}</option>
                            {/each}
                        </datalist>  
                </div>
                <div class="field is-grouped">
                    <div class="control">
                        <button class="button is-primary" type="submit">Save</button>
                    </div>
                    <!-- <div class="control">
                        <button class="button is-danger" type="button" on:click={() => { deleteTime(time) }}>Delete</button>
                    </div> -->
                    <div class="control">
                        <button 
                        type="reset" 
                        on:click={closeModal}
                        class="button is-primary is-light">Cancel</button>
                    </div>
                </div> 
            </form>     
        </section>
    </div>
</div>
{#if deleteTimeModal}
<DeleteTimeModal {time} />
{/if}
    